export default "__VITE_ASSET__Bd16M_1a__"